export default __webpack_public_path__ + "static/media/emptyassets.2f569d1c.png";